import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { useCookieConsentContext } from "@/contexts/CookieConsentContext";
import { cookieBannerContent, cookieCategories } from "@/content/legalContent";

const CookieSettingsDialog = () => {
  const { showSettings, closeSettings, savePreferences, preferences } = useCookieConsentContext();

  const [stats, setStats] = useState(false);
  const [marketing, setMarketing] = useState(false);

  useEffect(() => {
    if (showSettings && preferences) {
      setStats(preferences.statistics);
      setMarketing(preferences.marketing);
    } else if (showSettings) {
      setStats(false);
      setMarketing(false);
    }
  }, [showSettings, preferences]);

  return (
    <Dialog open={showSettings} onOpenChange={(open) => !open && closeSettings()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-base">{cookieBannerContent.settingsTitle}</DialogTitle>
          <DialogDescription className="text-xs leading-relaxed">
            {cookieBannerContent.settingsDescription}
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          {cookieCategories.map((cat) => {
            const checked =
              cat.id === "necessary" ? true : cat.id === "statistics" ? stats : marketing;
            const onToggle =
              cat.id === "statistics"
                ? () => setStats((v) => !v)
                : cat.id === "marketing"
                ? () => setMarketing((v) => !v)
                : undefined;

            return (
              <div key={cat.id} className="flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">{cat.label}</p>
                  <p className="text-xs text-muted-foreground leading-relaxed mt-0.5">
                    {cat.description}
                  </p>
                </div>
                <Switch
                  checked={checked}
                  onCheckedChange={onToggle}
                  disabled={cat.locked}
                  aria-label={cat.label}
                  className="shrink-0 mt-0.5"
                />
              </div>
            );
          })}
        </div>

        <DialogFooter>
          <Button size="sm" onClick={() => savePreferences(stats, marketing)} className="w-full text-xs h-9">
            {cookieBannerContent.save}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CookieSettingsDialog;
